module.exports = __webpack_public_path__ + "static/media/save_blue.6b54af48.png";